import React from 'react';
import Button from '../Button/Button';
import SectionTitle from '../SectionTitle/SectionTitle';
import styles from './DiscountSection.module.css';

const DiscountSection = () => {
    return (
        <div className={styles.discountSection}>
            <div className="container">
                <div className="row">
                    <div className="col-sm-12 col-lg-6">
                        <div className={`${styles.singleItem} ${styles.left}`}>
                            <h4>-20% Discount</h4>
                            <SectionTitle 
                                title="Discount on Rifles"
                            />
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Ipsum has been.</p>
                            <Button 
                                text="Buy Now"
                                link="/"
                            />
                        </div>
                    </div>
                    <div className="col-sm-12 col-lg-6">
                        <div className={`${styles.singleItem} ${styles.right}`}>
                            <h4>-20% Discount</h4>
                            <SectionTitle 
                                title="Discount on Shotgun"
                            />
                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry Ipsum has been.</p>
                            <Button 
                                text="Buy Now"
                                link="/"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DiscountSection;